import { getSelectedLanguage } from '@frontend/translate';
import { TableHeader } from '../../../../../elements/common';

export function MedicationsAddEditTableHeader(props: {}) {
    const translate = getSelectedLanguage();

    return (
        <>
            <TableHeader>{translate.common.name}</TableHeader>
            <TableHeader>{translate.medications.dosageInstruction}</TableHeader>
            <TableHeader>{translate.medications.startDate}</TableHeader>
            <TableHeader>{translate.medications.endDate}</TableHeader>
            <TableHeader></TableHeader>
        </>
    );
}
